<script lang="ts">
  import { tick } from 'svelte';

  import Input from '$shared/atoms/Input/Input.svelte';
  import AutoCompleteList from './_partial/AutoCompleteList.svelte';
  import GlobalListHOC from '$shared/molecules/GlobalListHOC/GlobalListHOC.svelte';

  interface Props {
    loading?: boolean;
    canCreate?: boolean;
    showCreateInfo?: boolean;
    isEditable?: boolean;
    createLabel?: string;
    showRequiredInfo?: boolean;
    infoLabel?: string;
    label?: string;
    name?: string;
    value?: string;
    error?: string;
    placeholder?: string;
    disabled?: boolean;
    tabIndex?: number;
    required?: boolean;
    list?: any;
    hasOverflow?: boolean;
    canCreateOnInput?: boolean;
    onclick?: (item: any) => void;
    oncreate?: (value: string) => void;
    oncleared?: () => void;
    onclicklisticon?: (item: any) => void;
  }

  let {
    loading = false,
    canCreate = false,
    showCreateInfo = false,
    isEditable = false,
    createLabel = '',
    showRequiredInfo = false,
    infoLabel = '',
    label = '',
    name = '',
    value = $bindable(''),
    error = $bindable(''),
    placeholder = '',
    disabled = false,
    tabIndex = 1,
    required = true,
    list = [],
    hasOverflow = false,
    canCreateOnInput = false,
    onclick,
    oncreate,
    oncleared,
    onclicklisticon
  }: Props = $props();
  export const setValue = (val: string) => {
    value = val;
    selectedItem = val;
  };

  let parent: HTMLDivElement;
  let refInput: Input;
  let showList = $state(false);
  let filteredList = $state([]);
  let selectedItem: any = null;
  let appWithList: GlobalListHOC;

  $effect(() => {
    if (!value || value === '') {
      filteredList = [...list];
    } else {
      filteredList = list.filter((item) =>
        item?.label?.toLowerCase().includes(value.toLowerCase())
      );
    }
  });

  const onClickListItem = (item): void => {
    selectedItem = item;
    value = item.label || '';
    onclick?.(item);
    showList = false;
    removeInputFocus();
  };

  const onInputChange = (detail: { value: string }): void => {
    value = detail.value.trim() || '';

    if (canCreateOnInput) {
      oncreate?.(value);
      selectedItem = value;
      return;
    }
    selectedItem = null;
    oncleared?.();
  };

  const onShowList = (): void => {
    showList = true;
    tick().then(() => {
      appWithList?.setListPosition();
    });
  };

  const onBlur = (): void => {
    setTimeout(() => {
      if (canCreate || canCreateOnInput) {
        if (!selectedItem) {
          value = '';
          showList = false;
        }
        return;
      }
      const filteredValue = filteredList.find(
        (item) => item?.label?.toLowerCase() === value?.toLowerCase()
      );
      if (!filteredValue) {
        value = '';
        selectedItem = null;
        oncleared?.();
      }
    }, 200);
  };

  const onClickWindow = (e: any): void => {
    if (parent && !parent.contains(e.target)) {
      showList = false;
    }
  };

  const onClickCreate = (): void => {
    oncreate?.(value);
    selectedItem = value;
    showList = false;
    removeInputFocus();
  };

  const focusInput = () => {
    refInput.focus();
  };

  const removeInputFocus = () => {
    refInput.blur();
  };

  const onIconClick = (item) => {
    showList = false;
    oncleared?.();
    onclicklisticon?.(item);
    removeInputFocus();
  };
</script>

<svelte:window onmouseup={onClickWindow} />

{#snippet labelSnippet()}
  <div class="dropdown-input" title={value}>
    <Input
      bind:this={refInput}
      icon="icon-chevron-down"
      {loading}
      {label}
      {name}
      {value}
      {error}
      {placeholder}
      {disabled}
      {tabIndex}
      {required}
      onfocus={onShowList}
      onblur={onBlur}
      oninput={onInputChange}
      onclickicon={onShowList}
    />
  </div>
{/snippet}

{#snippet listSnippet()}
  <div data-cy={`${name}-list`} class="list" onmousedown={(e) => { e.preventDefault(); focusInput(); }}>
    <AutoCompleteList
      {filteredList}
      canCreate={canCreate || canCreateOnInput}
      {showCreateInfo}
      {createLabel}
      {value}
      {isEditable}
      {showRequiredInfo}
      {infoLabel}
      onclickListItem={onClickListItem}
      oniconClick={onIconClick}
      onclickCreate={onClickCreate}
    />
  </div>
{/snippet}

<div bind:this={parent} class="comp-auto-complete">
  <GlobalListHOC bind:this={appWithList} show={!disabled && showList} {hasOverflow} label={labelSnippet} list={listSnippet} />
</div>

<style>
  .comp-auto-complete {
    position: relative;
  }
  .list {
    display: flex;
    background-color: #fff;
    flex-direction: column;
    border: 1px solid #e5e5e5;
    box-shadow:
      0px 3px 11px 1px rgba(0, 0, 0, 0.0783708),
      0px 7px 18px 3px rgba(0, 0, 0, 0.1);
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-height: 200px;
    z-index: 99;
    overflow: auto;
  }
</style>
